'use client'

import { motion } from 'framer-motion'
import { CSSProperties } from 'react'

import { cn } from '@/util/cn'
import useMarqueeColumns from '../../hooks/use-marquee-columns'

type Props = {
    className?: string
}

const StaffGrid = ({ className }: Props) => {
    const { columns, x, config } = useMarqueeColumns()
    
    return (
        <div 
            className={cn('relative w-full overflow-hidden', className)} 
            style={{ '--gutter': `${config.gutter}px` } as CSSProperties}
        >
            <motion.div className="relative left-0 top-0 flex gap-(--gutter)" style={{ x }}>
                {columns.map((col, index) => (
                    <div
                        key={col.stack[0]?.name ? `${col.stack[0].name}-${index}` : index}
                        className={cn('flex flex-col gap-(--gutter)', col.offsetClass)}
                    >
                        {col.stack.map((member) => (
                            <div 
                                key={member.name} 
                                className="bg-[#1C1C1C] w-full aspect-square"
                                style={{ width: col.width }}
                                >
                                <img
                                    alt={member.name}
                                    src={member.gif}
                                    className="w-full h-full object-cover"
                                />
                            </div>
                        ))}
                    </div>
                ))}
            </motion.div>
        </div>
    )
}

export default StaffGrid
